import { render } from "./TrimmingIconModal.vue?vue&type=template&id=2e08c73a&scoped=true"
import script from "./TrimmingIconModal.vue?vue&type=script&lang=js"
export * from "./TrimmingIconModal.vue?vue&type=script&lang=js"

import "./TrimmingIconModal.vue?vue&type=style&index=0&id=2e08c73a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e08c73a"]])

export default __exports__